export default __webpack_public_path__ + "static/media/black-icon.eb3ab915.svg";